import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/index.vue'),
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: () => import('@/views/about.vue'),
  },
  {
    path: '/service',
    name: 'service',
    component: () => import('@/views/service.vue'),
  },
  {
    path: '/activities',
    name: 'activities',
    component: () => import('@/views/activities/index.vue'),
  },
  {
    path: '/activities/article/:id',
    name: 'article',
    component: () => import('@/views/activities/article.vue'),
  },
  {
    path: '/donation',
    name: 'donation',
    component: () => import('@/views/donation.vue'),
  },
  {
    path: '/reservation',
    name: 'reservation',
    component: () => import('@/views/reservation.vue'),
  },
  {
    path: '/volunteer',
    name: 'volunteer',
    component: () => import('@/views/volunteer/index.vue'),
    children: [
      {
        path: '/volunteer/registration/:id',
        name: 'registration',
        component: () => import('@/views/volunteer/registration.vue'),
      },
    ],
  },
  {
    path: '/career',
    name: 'career',
    component: () => import('@/views/career/index.vue'),
    children: [
      {
        path: '/career/:id',
        name: 'info',
        component: () => import('@/views/career/info.vue'),
      },
    ],
  },
  {
    path: '*',
    name: 'pageError',
    component: () => import('@/views/pageError.vue'),
  },
  {
    path: '/journal',
    name: 'journal',
    component: () => import('@/views/journal.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
